import { RView1jxdnn5qf89cm as RView } from '../RView.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SpaceClass;
function Space() {
  if (SpaceClass === VOID) {
    class $ extends RView() {
      constructor(context, multiplier) {
        multiplier = multiplier === VOID ? 1.0 : multiplier;
        super(context);
        this.tb5_1.xb3_1 = 'span';
        this.tb5_1.hb4_1.v('kiteui-space');
        this.tb5_1.ab9('--space-multiplier', multiplier.toString());
      }
    }
    initMetadataForClass($, 'Space');
    SpaceClass = $;
  }
  return SpaceClass;
}
//region block: exports
export {
  Space as Spaceoq5xo9lsieqc,
};
//endregion

//# sourceMappingURL=Space.commonHtml.mjs.map
